export default '/bible/CCRBRP/0';